import { render, staticRenderFns } from "./Antiseptic.vue?vue&type=template&id=5297e67c&scoped=true&"
import script from "./Antiseptic.vue?vue&type=script&lang=js&"
export * from "./Antiseptic.vue?vue&type=script&lang=js&"
import style0 from "./Antiseptic.vue?vue&type=style&index=0&id=5297e67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297e67c",
  null
  
)

export default component.exports